export default __webpack_public_path__ + "static/media/Job Post Real.eab06e37.png";